"use strict";
/** @license See the LICENSE file. */
Object.defineProperty(exports, "__esModule", { value: true });
// This code is auto-generated, do not modify this file!
var version = '1.7.0';
exports.version = version;
//# sourceMappingURL=version.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@tensorflow/tfjs-core/dist/version.js
 ** module id = 1085
 ** module chunks = 0
 **/